import { deviceType } from './featured-constants';

export const getDeviceType = () => {
  let device = deviceType.DESKTOP;

  const width = window.innerWidth;
  const ua = navigator.userAgent;
  if (/tablet|ipad|playbook|silk/i.test(ua) || (width >= 768 && width <= 991)) {
    device = deviceType.TABLET;
  } else if (/Mobile|Android|iP(hone|od)|IEMobile|WPDesktop|FxiOS|Opera Mini/i.test(ua) || width < 768) {
    device = deviceType.MOBILE;
  } else {
    device = deviceType.DESKTOP;
  }
  return device;
};

export const convertToBoolean = (value: any): boolean => {
  return value !== 'false' && value !== false && value !== 0 && value !== '0' && value !== null;
};

// END GENAI@CHATGPT4

export function findNextFocusableElement(currentSelector: HTMLElement)  {
  const focusableElements = 'a, button, .vs-amb-video-btn, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  let currentElement = currentSelector;

  if (!currentElement) {
    return null;
  }

  function findFocusable(element) {
    if (!element) {
      return null;
    }

    if (element.matches(focusableElements)) {
      return element;
    }

    const children = element.querySelectorAll(focusableElements);
    if (children.length > 0) {
      return children[0];
    }

    return null;
  }

  let sibling = currentElement.nextElementSibling;

  while (sibling) {
    const focusable = findFocusable(sibling);
    if (focusable) {
      return focusable;
    }
    sibling = sibling.nextElementSibling;
  }

  return null;
}

export function handleScrollAndFocus(element: HTMLElement, rootElement) {
  if (element?.classList?.contains('vs-amb-video-btn')) {
    const closest = element?.closest('.vs-featured-screen');
    if (closest) {
      const index = closest.getAttribute('data-index');
      const wrappers: any = Array.from(rootElement?.querySelectorAll('.vs-fc-text-wrapper'));
      if (index !== null && wrappers[parseInt(index)]) {
        wrappers[parseInt(index)].scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  } else {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  element.focus();
}

export function handleKeyDown(event, focusableElementsArr, rootElement) {
  const currentIndex = focusableElementsArr.indexOf(document.activeElement as HTMLElement);
  const isShiftPressed = event.shiftKey;
  const nextIndex = isShiftPressed ? currentIndex - 1 : currentIndex + 1;
  const isFirstElement = currentIndex === 0;
  const isLastElement = currentIndex === focusableElementsArr.length - 1;
  const isTabPressed = event.key === 'Tab';

  const updateTabIndices = (indexToEnable: number) => {
    focusableElementsArr.forEach((element, index) => {
      element.tabIndex = index === indexToEnable ? 0 : -1;
    });
  };

  if (isTabPressed) {
    if (isLastElement && !isShiftPressed) {
      const nextFocusableElement = findNextFocusableElement(rootElement);
      updateTabIndices(focusableElementsArr?.length - 1);
      if (nextFocusableElement) {
        setTimeout(() => nextFocusableElement.focus(), 100);
      }
      return;
    }

    if (isFirstElement && isShiftPressed) {
      updateTabIndices(0);
      return;
    }

    if ((isShiftPressed && !isFirstElement) || (!isShiftPressed && !isLastElement)) {
        event.preventDefault();
        if (focusableElementsArr && nextIndex >= 0 && nextIndex < focusableElementsArr.length) {
          handleScrollAndFocus(focusableElementsArr[nextIndex], rootElement);
        }
      }
  }
}
